'use strict';

var _Object$assign = require('babel-runtime/core-js/object/assign')['default'];

require('babel/polyfill');

var environment = ({
  development: {
    isProduction: false
  },
  production: {
    isProduction: true
  }
})[process.env.NODE_ENV || 'development'];

module.exports = _Object$assign({
  host: process.env.HOST || 'localhost',
  port: process.env.PORT,
  apiHost: process.env.APIHOST || 'localhost',
  apiPort: process.env.APIPORT,
  wpApiHost: 'wp.blog.paymentwall.com',
  wpApiEndpoint: '/wp-json/wp/v2',
  gaUa: 'UA-57535476-1',
  facebookAppId: '1040991065974499',
  app: {
    title: 'Paymentwall Blog | Tech & Business News',
    description: 'Paymentwall Blog is a leading tech and business media publisher, dedicated to provide the latest industry trends, business monetization tips, and breaking news.',
    head: {
      titleTemplate: '%s | Paymentwall',
      meta: [{ name: 'description', content: 'Paymentwall Blog is a leading tech and business media publisher, dedicated to provide the latest industry trends, business monetization tips, and breaking news.' }, { charset: 'utf-8' }, { property: 'og:site_name', content: 'Paymentwall Blog' }, { property: 'og:image', content: '' }, { property: 'og:locale', content: 'en_US' }, { property: 'og:title', content: 'Paymentwall Blog' }, { property: 'og:description', content: 'Paymentwall Blog is a leading tech and business media publisher, dedicated to provide the latest industry trends, business monetization tips, and breaking news.' }]
    }
  }

}, environment);


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 180
// module chunks = 0